//everything here is great, except the method names could be more exact

// formatDateYYYYMMDD
// formatDateMMYY
// formatDateFooBarBaz

export const dateFormatter = (docDate: string) => {
  if (docDate) {
    const splitDate = docDate.split("T")[0].split("-");
    return `${splitDate[2]}.${splitDate[1]}.${splitDate[0].slice(2)}`;
  }
  return "";
};

export const dateMonthFormat = (date: string) => {
  if (date) {
    const splitDate = date.split("T")[0].split("-");
    return `${splitDate[1]}.${splitDate[0]}`;
  }
  return "";
};

export const dateDayFormat = (date: string) => {
  if (date) {
    const splitDate = date.split("T")[0].split("-");
    return `${splitDate[2]}.${splitDate[1]}`;
  }
  return "";
};

export const dateDotFormat = (date: string) => {
  if (date) {
    const splitDate = date.split("T")[0].split("-");
    return `${splitDate[2]}.${splitDate[1]}.${splitDate[0]}`;
  }
  return "";
};

export const dateSlashFormat = (
  date: string,
  cut?: boolean,
  monthCut?: boolean
) => {
  if (date) {
    const splitDate = date.split("T")[0].split("-");
    if (cut) {
      return `${splitDate[2]}/${splitDate[1]}/${splitDate[0].slice(2)}`;
    }
    if (monthCut) {
      return `${splitDate[1]}/${splitDate[0].slice(2)}`;
    }
    return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
  }
  return "";
};

export const getDateFormatMMYYYY = (date: string) => {
  if (!date) return "";
  const splitDate = date.split("T")[0].split("-");
  return `${splitDate[1]}/${splitDate[0]}`;
};

export const pdfDateFormatter = (docDate: string) => {
  if (docDate) {
    const splitDate = docDate.split("T")[0].split("-");
    return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
  }
  return "";
};

export const getFromDateValue = () => {
  let today = new Date();
  today.setFullYear(today.getFullYear() - 3);
  today.setMonth(0);
  today.setDate(1);
  return today;
};
